import React from "react";
import { CardOfTheDayCard } from "../ui/cards/CardOfTheDayCard";
import { AstroPrognoseCards } from "../ui/cards/AstroPrognoseCards";
import { ZodiaPrognoseCard } from "../ui/cards/ZodiaPrognoseCard";
import { LuckyCard } from "../ui/cards/LuckyCard";
import { CardOfTheDayStatus } from "../types/CardOfTheDayStatus";
import { AstroPrognosisStatus } from "../types/AstroPrognosisStatus";
import { ZodiacalPrognosisStatus } from "../types/ZodiacalPrognosisStatus";
import { LuckyCardStatus } from "../types/LuckyCardStatus";

interface MainContentProps {
  cardOfTheDayStatus: CardOfTheDayStatus | null ;
  astroPrognosisStatus: AstroPrognosisStatus | null;
  zodiacalPrognosisStatus: ZodiacalPrognosisStatus | null;
  luckyCardStatus: LuckyCardStatus | null;
  navigateToCardOfTheDay: () => void;
  navigateToAstroPrognosis: () => void;
  navigateToZodiacPrognosis: () => void;
  navigateToLuckyCard: () => void;
  gridSettings: any[];
}

export const MainContent: React.FC<MainContentProps> = ({ 
  cardOfTheDayStatus,
  astroPrognosisStatus,
  zodiacalPrognosisStatus,
  luckyCardStatus,
  navigateToCardOfTheDay,
  navigateToAstroPrognosis,
  navigateToZodiacPrognosis,
  navigateToLuckyCard,
  gridSettings
}) => (
  <>
    <CardOfTheDayCard
      cardOfTheDayStatus={cardOfTheDayStatus}
      navigateToCardOfTheDay={navigateToCardOfTheDay}
      gridColumn={gridSettings[0].gridColumn}
      gridRow={gridSettings[0].gridRow}
    />
    <AstroPrognoseCards
      navigateToAstroPrognosis={navigateToAstroPrognosis}
      astroPrognosisStatus={astroPrognosisStatus}
      gridColumn={gridSettings[1].gridColumn}
      gridRow={gridSettings[1].gridRow}
    />
    <ZodiaPrognoseCard
      navigateToZodiacPrognosis={navigateToZodiacPrognosis}
      zodiacalPrognosisStatus={zodiacalPrognosisStatus}
      gridColumn={gridSettings[2].gridColumn}
      gridRow={gridSettings[2].gridRow}
    />
    <LuckyCard
      navigateToLuckyCard={navigateToLuckyCard}
      luckyCardStatus={luckyCardStatus}
      gridColumn={gridSettings[3].gridColumn}
      gridRow={gridSettings[3].gridRow}
    />
  </>
); 